import type { DomApplier } from '../cssFeatures.types'
import type { SelectorObj } from '../../shared.types'
import type { TransitionData } from '@wix/thunderbolt-becky-types'
import { getVariantSelectors } from '../../utils/variantsUtils'

export const NOT_ANIMATING_SCREEN_IN_SELECTOR = ':not(.is-animating)'

const getCSSObjectFromTransitionItem = (styleItem: TransitionData) => {
	const property = 'all'
	const { 'timing-function': timingFunction = 'ease', duration = 0, delay = 0 } = styleItem

	// visibility property will cause a delay when hiding the component via Velo hide() API
	const transition = `${property} ${duration}s ${timingFunction} ${delay}s, visibility 0s`
	return { transition, '--transition': transition }
}

export const transitionsDomApplier: DomApplier<'transitions'> = (
	{ id: compId },
	idSelector,
	breakpointId,
	{ transitionsVariants, transitions },
	accumulatedData
) => {
	if (!transitions) {
		return null
	}

	const { breakpointToTransition, type } = transitions

	const transitionsInBreakpoint = breakpointToTransition[breakpointId] || {}

	return Object.entries(transitionsInBreakpoint).reduce<SelectorObj>((acc, [variantKey, transitionData]) => {
		const variantSelectors = transitionsVariants
			? getVariantSelectors(variantKey, transitionsVariants, compId, accumulatedData)
			: ['']

		const hasCondition = !!transitionsVariants?.[variantKey]

		// We test against WRichText because sometimes it gets inflated with inner `<span>` and in transition
		// will make the transition occur again (thus causing a delay-like behavior), see TB-10024
		const shouldApplyTransitionOnAllChildren = type === 'Component'

		const cssFromTransitionItem = getCSSObjectFromTransitionItem(transitionData)

		const domSelector = variantSelectors
			.map((variantSelector) => {
				const selectorWithChildren = shouldApplyTransitionOnAllChildren
					? `${variantSelector}, ${variantSelector} `
					: `${variantSelector}, ${variantSelector} > `

				return `${hasCondition ? selectorWithChildren : `${idSelector}`}${NOT_ANIMATING_SCREEN_IN_SELECTOR}`
			})
			.join(',')

		acc[domSelector] = Object.assign(acc[domSelector] || {}, cssFromTransitionItem)

		if (shouldApplyTransitionOnAllChildren) {
			acc[`${domSelector} ${NOT_ANIMATING_SCREEN_IN_SELECTOR}`] = Object.assign(
				acc[`${domSelector} ${NOT_ANIMATING_SCREEN_IN_SELECTOR}`] || {},
				{ ...cssFromTransitionItem }
			)
		}
		return acc
	}, {})
}
